import React from "react";
import {
  Modal,
  Button,
  FormGroup,
  FormControl,
  InputGroup
} from "react-bootstrap";
import slugify from "slugify";
import { post } from "../../utils/apiService";
import { connect } from "react-redux";

import { updateVideo } from "../../actions";

class VideoConvertedUserStatusModal extends React.Component {
  constructor() {
    super();

    this.state = {
      isLoading: false,
      isSaving: false,
      isInvalid: false,
      conversionFields: [],
      count: 0
    };

    this.submitForm = this.submitForm.bind(this);
    this.addConversionField = this.addConversionField.bind(this);
    this.removeConversionField = this.removeConversionField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  handleInputChange(e, fieldName) {
    let conversionFields = [...this.state.conversionFields];
    let updatedConversionFields = conversionFields.map(field => {
      if (field.name === fieldName) {
        field.value = e.target.value;
      }
      return field;
    });
    this.setState({
      conversionFields: updatedConversionFields
    });
  }
  addConversionField() {
    let conversionFields = [...this.state.conversionFields];
    conversionFields.push({
      name: `field-${this.state.count}`,
      value: "",
      placeholder: "Nome:"
    });
    this.setState({
      conversionFields,
      count: this.state.count + 1
    });
  }
  removeConversionField(e, fieldName) {
    let conversionFields = [...this.state.conversionFields];
    let updatedConversionFields = conversionFields.filter(field => {
      return field.name !== fieldName;
    });
    this.setState({
      conversionFields: updatedConversionFields
    });
  }
  async submitForm(event) {
    const { video, updateVideo } = this.props;
    event.preventDefault();

    let parsedConversionFields = [];

    this.state.conversionFields.forEach(field => {
      parsedConversionFields.push({
        name: slugify(field.value),
        label: field.value,
        value: false
      });
    });

    console.log("Submetendo... ", parsedConversionFields);
    let url = `/campaigns/${video.campaign_id}/videos/${
      video.id
    }/set_converted_user_status`;
    let data = {
      converted_user_status: parsedConversionFields
    };

    try {
      let response = await post(url, data);
      let updatedVideo = response.data;
      updateVideo(video.campaign_id, updatedVideo);
    } catch (err) {
      console.log("Deu erro: ", err);
    }
  }
  render() {
    const { show, close, video } = this.props;
    console.log("video: ", video);
    return (
      <Modal show={show} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>Configuração de Usuários Convertidos</Modal.Title>
        </Modal.Header>
        <form onSubmit={this.submitForm}>
          <Modal.Body>
            {video.converted_user_status === null && (
              <div>
                <p>Adicione um campo para cada item de conversão</p>

                {this.state.conversionFields.map((field, index) => (
                  <FormGroup key={index}>
                    <InputGroup>
                      <FormControl
                        type="text"
                        value={field.value}
                        placeholder={field.placeholder}
                        onChange={e => {
                          this.handleInputChange(e, field.name);
                        }}
                      />
                      <InputGroup.Button>
                        <Button
                          onClick={e => {
                            this.removeConversionField(e, field.name);
                          }}
                        >
                          Remover
                        </Button>
                      </InputGroup.Button>
                    </InputGroup>
                  </FormGroup>
                ))}
                <FormGroup>
                  <Button onClick={this.addConversionField}>
                    Adicionar Campo
                  </Button>
                </FormGroup>
              </div>
            )}
            {video.converted_user_status !== null && (
              <p>Video já configurado!</p>
            )}
          </Modal.Body>

          <Modal.Footer>
            <button type="button" className="btn btn-link" onClick={close}>
              Fechar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ textTransform: "capitalize" }}
              disabled={
                this.state.isSaving ||
                this.state.isLoading ||
                this.state.isInvalid
              }
            >
              Salvar
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video));
  }
});

export default connect(null, mapDispatchToProps)(VideoConvertedUserStatusModal);



// WEBPACK FOOTER //
// ./src/components/modals/VideoConvertedUserStatusModal.js